var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AddDiscountModule',{attrs:{"detail":_vm.detail,"update":false},on:{"saveDetail":_vm.saveDiscount,"newProductAdd":_vm.newProductAdd,"cancelCreate":_vm.cancelCreate,"deleteTempItem":_vm.deleteTempItem}})
}
var staticRenderFns = []

export { render, staticRenderFns }